import React, { useEffect, useState } from "react";
import Table from 'UI/Table';
import { Query } from "Utilities/incognitaAPI"
import moment from 'moment'
import Icon from 'UI/FontAwesomeIcon'
import { isEmpty } from "lodash";

const GET_DATA = `
  query ImportConfigurationReport($id: ID!, $pageSize: Int!, $page: Int!) {
    importConfigurationReportAffectedAssets(id: $id, pageSize: $pageSize, page: $page) {
      totalCount
      assets {
        id
        name
        lastSeenAt
        dataGatheredAt
        deletedAt
        issues
      }
    }
  }
`

const COLUMNS = [
  { Header: 'ID', accessor: 'id', width: 100 },
  { Header: 'Name', accessor: 'name' },
  { Header: 'Last Seen At', accessor: 'lastSeenAt', width: 200, Cell: row => (
    <div className="text-center">
      {row.value ?
        moment.utc(new Date(row.value)).format('YYYY-MM-DD  hh:mm A') :
        <Icon icon="minus" className="text-2xl text-gray-700" />
      }
    </div>
  ) },
  { Header: 'Data Gathered At', accessor: 'dataGatheredAt', width: 200, Cell: row => (
    <div className="text-center">
      {row.value ?
        moment.utc(new Date(row.value)).format('YYYY-MM-DD  hh:mm A') :
        <Icon icon="minus" className="text-2xl text-gray-700" />
      }
    </div>
  )},
  { Header: 'Deleted At', accessor: 'deletedAt', width: 200, Cell: row => (
    <div className="text-center">
      {row.value ?
        moment.utc(new Date(row.value)).format('YYYY-MM-DD  hh:mm A') :
        <Icon icon="minus" className="text-2xl text-gray-700" />
      }
    </div>
  )},
  { Header: 'Issues', accessor: 'issues', Cell: (row) => <div>{row.value.map(i => <div>- {i}</div>)}</div> },
]

const AffectedAssets = ({ configID }) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [pages, setPages] = useState(1)
  const [errors, setErrors] = useState([])

  const fetchData = () => {
    setLoading(true)

    Query(GET_DATA, { id: configID, pageSize, page })
      .then((res) => {
        if (res?.errors) {
          setErrors(res.errors.map(e => e.message))
          setData([])
        } else {
          setData(res?.importConfigurationReportAffectedAssets?.assets)
          handlePages(res?.importConfigurationReportAffectedAssets?.totalCount)
          setErrors([])
        }
      })
      .catch(error => setErrors([error]))
      .finally(() => setLoading(false))
  }

  const handlePages = (totalCount) => setPages(Math.ceil(totalCount / pageSize))

  useEffect(fetchData, [page, pageSize])

  const NoDataComponent = () => {
    if (!isEmpty(errors)) return (
      <div className="text-center text-red-600 py-4">ERROR: {errors.join(', ')}</div>
    )

    return (
      <div className="text-center font-medium text-lg py-3 text-gray-700">
        No Issues
      </div>
    )
  }

  return (
    <div>
      <Table
        columns={COLUMNS}
        data={data}
        loading={loading}
        pageSize={pageSize}
        NoDataComponent={NoDataComponent}
        page={page - 1}
        onPageChange={nextPage => setPage(nextPage + 1)}
        onPageSizeChange={setPageSize}
        pages={pages}
        manual
      />
    </div>
  )
}

export default AffectedAssets
